export const DEALERSHIP_OPTIONS = [
  { label: "София Люлин", email: "liulin2@motopfohe.bg" },
  { label: "София Младост", email: "mladost@motopfohe.bg" },
  { label: "Благоевград", email: "blagoevgrad@motopfohe.bg" },
  { label: "Бургас", email: "burgas@motopfohe.bg" },
  { label: "Варна", email: "varna@motopfohe.bg" },
  { label: "Велико Търново", email: "velikotarnovo@motopfohe.bg" },
  { label: "Габрово", email: "gabrovo@motopfohe.bg" },
  { label: "Добрич", email: "dobrich@motopfohe.bg" },
  { label: "Монтана", email: "montana@motopfohe.bg" },
  { label: "Плевен", email: "pleven@motopfohe.bg" },
  { label: "Пловдив", email: "plovdiv@motopfohe.bg" },
  { label: "Русе", email: "russe@motopfohe.bg" },
  { label: "Стара Загора", email: "starazagora@motopfohe.bg" },
  { label: "Смолян", email: "smolyan@motopfohe.bg" },
  { label: "Шумен", email: "forsh@motopfohe.bg" },
  { label: "Хасково", email: "g.draganov@autobox.bg" },
];

export function getDealershipByEmail(email) {
  return DEALERSHIP_OPTIONS.find((dealership) => dealership.email === email);
}
